// src/utils/theme.js
// 默认主题色
const defaultTheme = {
    primary: '#3b82f6'
}

// 设置主题色
export const setTheme = (theme = defaultTheme) => {
    // 把主题色注入到CSS变量中
    document.documentElement.style.setProperty('--theme-color', theme.primary);

    const r = parseInt(theme.primary.slice(1, 3), 16);
    const g = parseInt(theme.primary.slice(3, 5), 16);
    const b = parseInt(theme.primary.slice(5, 7), 16);
    
    document.documentElement.style.setProperty('--theme-r', r);
    document.documentElement.style.setProperty('--theme-g', g);
    document.documentElement.style.setProperty('--theme-b', b);

    // 保存到本地存储，刷新页面后仍生效
    sessionStorage.setItem('custom-theme', JSON.stringify(theme))
}

// 获取本地存储的主题色
export const getTheme = () => {
    const savedTheme = sessionStorage.getItem('custom-theme')
    return savedTheme ? JSON.parse(savedTheme) : defaultTheme
}

// 重置为默认主题
export const resetTheme = () => {
    setTheme(defaultTheme)
}